import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=66d77c2a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../less/scan.less?vue&type=style&index=0&id=66d77c2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d77c2a",
  null
  
)

export default component.exports